
/**
 * @export
 * @enum {string}
 */
export enum TriggerAttachmentType {
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO'
}